var app = angular.module("leonardo");

var OnDemandCategoryDetail = function($scope, $state, categoryObj, OnDemandInstructionService, FilterService,
                                      $controller, $q, $filter) {
  $scope.list_left = [];
  $scope.list_right = [];

  $scope.category = categoryObj;
  $state.current.ncyBreadcrumbLabel = $scope.category.name;
  $scope.category_param = $state.params.category;

  $scope.init_cols = function(list) {
    $scope.list_left = [];
    $scope.list_right = [];
    list = $filter('orderBy')(list, 'name')
    angular.forEach(list, function(value, key){
      if (key < list.length/2) {
        $scope.list_left.push(value);
      }
      else {
        $scope.list_right.push(value);
      }
    });
  };

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();
    options['search'] = FilterService.getFilter('search');
    if ($state.current.subcategory) {
      options['subcategories'] = $scope.category ? $scope.category.id : null;
      options['category'] = $scope.category_param;
    }
    else {
      options['category'] = $scope.category ? $scope.category.id : null;
    }
    OnDemandInstructionService.getlist(options).then(function(list) {
      var results = list.results ? list.results : list;
      $scope.init_cols(results);
      defer.resolve(list);
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.goToItem = function(item) {
    $state.go('on-demand-instructions.instruction', {pk: item.id});
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.loadPage(1);

};

app.controller('OnDemandCategoryDetail', ['$scope', '$state', 'categoryObj', 'OnDemandInstructionService',
  'FilterService', '$controller', '$q', '$filter', OnDemandCategoryDetail]);
